import React, { useState, useMemo, useRef } from 'react';

import { Button } from 'components/Button';
import { IOption } from 'components/Select/interface';

import { GreaterThan } from 'utils/Patterns/Specification';
import arrowDown from 'img/arrow-down-grey.svg';

import { MultiSelectProps } from './interface';
import { useOutsideClick } from 'hooks/useOutsideClick';

import './styles.scss';

const MultiSelect: React.FC<MultiSelectProps> = (props) => {
  const {
    allItems,
    itensSelected,
    width,
    placeHolderOne,
    placeHolderMany,
    className,
    style,
    show,
    setShow
  } = props;

  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, setShow);

  const [renderComponent, setRenderComponent] = useState(true);

  const getItensList = useMemo(() => {
    const _optionsCategories: Array<IOption> = new Array<IOption>();

    Object.keys(allItems).forEach((key) => {
      _optionsCategories.push({
        value: allItems[key].key || allItems[key].name,
        label: `${allItems[key].value || allItems[key].name}`,
      });

      return;
    });

    return _optionsCategories;
  }, [allItems]);

  const itensSelectedMultiSelect = useMemo(() => {
    return itensSelected;
  }, [itensSelected]);

  const disableCheckAll = (value: string) => {
    if (value === 'Todos') {
      itensSelected.splice(0, itensSelected.length);
    }
  };

  const handleprofilesFilter = (value: string) => {
    const index = itensSelected.indexOf(value);

    if (index !== -1) {
      itensSelected.splice(index, 1);
    } else {
      itensSelected.push(value);
    }

    disableCheckAll(value);

    setRenderComponent(!renderComponent);
  };

  const setLabelMultiSelect = (result: boolean) => {
    const getAllOption = getItensList.find(x => x.value === 'Todos');

    if (itensSelectedMultiSelect.length === 0 && !getAllOption) {
      return "Selecione";
    } else if (itensSelectedMultiSelect.length === 0 && getAllOption) {
      return "Todos";
    } else {
      return `${itensSelectedMultiSelect.length} ${result ? placeHolderMany : placeHolderOne}`;
    }
  };

  const getProfileFilter = () => {
    let ruleGroupSelected = new GreaterThan(1);

    let result = ruleGroupSelected.isSatisfiedBy(itensSelectedMultiSelect.length);

    return (
      <Button
        className="color-black"
        onClick={() => setShow(!show)}
      >
        {setLabelMultiSelect(result)}
      </Button>
    );
  };

  const setCheckedOption = (value: string) => {
    if (itensSelectedMultiSelect.length === 0 && value === 'Todos') {
      return true;
    } else {
      return itensSelectedMultiSelect.includes(value);
    }
  };

  return (
    <>
      <div ref={wrapperRef} className={`multiSelect-wrapper-ccare d-flex align-center pl-2 ${className}`} style={style}>
        {itensSelectedMultiSelect && getProfileFilter()}
        <a className={`arrow-down ${show && 'arrow-down-inverse'}`} onClick={() => setShow(!show)}>
          <img src={arrowDown} alt="" />
        </a>
        <ul
          className={
            show ? 'multiSelect-list multiSelect-list-ccare bg-white p-3 overflow-y-auto'
              : 'multiSelect-list bg-white shadow-1 p-3 d-none'
          }
          style={{ minWidth: width, minHeight: '100px', maxHeight: '280px' }}
        >
          {itensSelectedMultiSelect && getItensList.map((opt, key) => (
            <li className="multiSelect-item d-flex mb-2 mt-2" key={key}>
              <input
                checked={setCheckedOption(opt.value)}
                onChange={(_e) => handleprofilesFilter(opt.value)}
                className="mr-2 check-multiselect"
                type="checkbox"
                value={opt.value}
                name={`cat-${opt.value}`}
                id={`cat-${opt.value}`}
              />
              <label htmlFor={`cat-${opt.value}`}>{opt.label}</label>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default MultiSelect;
